
<template>
  <!-- <div> -->
    <v-col cols='12' style="border: solid 1px #aaa; border-radius: 8px" class="white">
      <slot name='title'></slot>
      <!-- <div class="headline">
        <v-row class="mx-1" align="center">
          Ativos descontados
          <v-spacer></v-spacer>
          <filter-items ref="dateFilter" :indexFilter="getPartial"></filter-items>
        </v-row>
      </div> -->
      <v-col cols='12' md='10' offset-md='1' offset-xs='0' class="text-center">
        <v-row justify="space-between" class="px-10">
          <v-col cols='6' md='3'>
            <v-card style="border-radius:12px" outlined flat>
              <v-card-text class="px-3 py-0">
                <v-row justify="space-between" align='center'>
                  <v-col class="py-1 pr-0 title text-center" cols='4'>
                    {{lost_items}}
                  </v-col>
                  <v-col class="py-1 pl-0 text-center">
                    NFs
                    <v-icon class="ml-3">mdi-file-document-outline</v-icon>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols='6' md='3'>
            <v-card style="border-radius:12px" outlined flat>
              <v-card-text class="px-3 py-0">
                <v-row justify="space-between" align='center'>
                  <v-col class="py-1 pr-0 title text-center" cols='4'>
                    {{lost_sent}}
                  </v-col>
                  <v-col class="py-1 pl-0 text-center">
                    Enviados
                    <v-icon class="ml-3">mdi-arrow-top-right-thin-circle-outline</v-icon>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols='6' md='3'>
            <v-card style="border-radius:12px" outlined flat>
              <v-card-text class="px-3 py-0">
                <v-row justify="space-between" align='center'>
                  <v-col class="py-1 pr-0 title text-center" cols='4'>
                    {{lost_returned}}
                  </v-col>
                  <v-col class="py-1 pl-0 text-center">
                    Retornados
                    <v-icon class="ml-3">mdi-arrow-bottom-left-thin-circle-outline</v-icon>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols='6' md='3'>
            <v-card style="border-radius:12px" outlined flat>
              <v-card-text class="px-3 py-0">
                <v-row justify="space-between" align='center'>
                  <v-col class="py-1 pr-0 title text-center" cols='4'>
                    {{lost_ammount}}
                  </v-col>
                  <v-col class="py-1 pl-0 text-center">
                    Descontados
                    <v-icon class="ml-2">mdi-call-missed</v-icon>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols='12'>
        <v-row class="px-5" justify="center">
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-0"
            :search="search"
            :options.sync="talbeOptions"
            :loading='loading_dash'
            ref="table"
          >
            <template v-slot:top>
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontre"></v-text-field>
            </template>

            <template v-slot:item.date="{ item }">
              {{(item.in_cash) | moment('DD/MM/YYYY')}}
            </template>
          </v-data-table>
        </v-row>
      </v-col>
    </v-col>
  <!-- </div> -->
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    FilterItems: () => import("@/components/shared/DateRangeFilter"),
  },
  props: {
    items: {
      type: Array,
    },
    loading_dash: {
      type: Boolean,
    }
  },
  data() {
    return {
      key: null,
      headers: [
        {text: 'Doc Cliente', value: 'client', },
        {text: 'NF', value: 'nf', },
        {text: 'Transportadora', value: 'trans', align: 'center'},
        {text: 'DT', value: 'dt', align: 'center'},
        {text: 'Placa', value: 'plate', align: 'center'},
        {text: 'Saída', value: 'date', align: 'center'},
        {text: 'Enviados', value: 'sent', align: 'center'},
        {text: 'Retornados', value: 'returned', align: 'center'},
        // {text: 'Transportadora', value: 'name', },
      ],
      talbeOptions:{
        itemsPerPage: 10,
        sortBy: ['pallets'],
        sortDesc: [true],
        mustSort: [true],
      },
      search: null,
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    lost_items() {
      let data = 0
      if (this.items && this.items.length){
        data = this.$refs.table.internalCurrentItems
        data = data.length
      }
      return data 
    },
    lost_returned() {
      let data = 0
      if (this.items && this.items.length){
        data = this.$refs.table.internalCurrentItems
        data = data.reduce((acc, one)=> (acc + Number(one.returned)), 0)
      }
      return data 
    },
    lost_sent() {
      let data = 0
      if (this.items && this.items.length){
        data = this.$refs.table.internalCurrentItems
        data = data.reduce((acc, one)=> (acc + Number(one.sent)) , 0)
      }
      return data 
    },
    lost_ammount() {
      let data = 0
      if (this.items && this.items.length){
        data = this.$refs.table.internalCurrentItems
        console.log({data});
        data = data.reduce((acc, one)=> (acc + (Number(one.sent) - Number(one.returned)) ), 0 )
      }
      return data 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>
